<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader title="Ecommerce Products" title1="Online catalogue" />
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Status</th>
                    <th>Featured</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in products" :key="item.ecommerce_item_id">
                    <td>{{ item.itemname }}</td>
                    <td>{{ money(item.online_price || item.unit_price) }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>
                      <span class="badge" :class="item.is_active ? 'bg-success' : 'bg-secondary'">
                        {{ item.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td>{{ item.is_featured ? 'Yes' : 'No' }}</td>
                  </tr>
                  <tr v-if="!loading && products.length === 0">
                    <td colspan="5" class="text-center text-muted py-4">No ecommerce products found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ecommerce-products',
  data() {
    return {
      loading: false,
      products: [],
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    async loadProducts() {
      this.loading = true;
      try {
        const response = await axios.get('/v1/ecommerce/items');
        this.products = response.data || [];
      } finally {
        this.loading = false;
      }
    },
    money(value) {
      const amount = Number(value || 0);
      return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },
  },
};
</script>
